// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

export interface DeleteWorkshopNoteRequestPayload {
  id: number;
  noteId: string;
}
export interface DeleteWorkshopNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface DeleteWorkshopNoteFailPayload {
  error: Error;
}

export const deleteWorkshopNoteActions = createAsyncAction(
  'elearning/DELETE_WORKSHOP_NOTE_REQUEST',
  'elearning/DELETE_WORKSHOP_NOTE_SUCCESS',
  'elearning/DELETE_WORKSHOP_NOTE_FAIL'
)<DeleteWorkshopNoteRequestPayload, DeleteWorkshopNoteSuccessPayload, DeleteWorkshopNoteFailPayload>();
